import React from 'react';
import { Button } from '../components/ui/button';

const Services = () => {
  const services = [
    {
      id: 1,
      title: 'AHPRA-Compliant Social Media Management',
      description: 'Consistent, professional content that builds trust with referred patients.',
      fullDescription: 'As a Registered Nurse with 16 years of clinical experience and 11 years working with private specialists, I understand your world inside and out. I create content that sounds authentically like you, builds trust with referred patients before they ever call your rooms, and stays 100% AHPRA compliant. No cookie-cutter templates. No generic medical stock photos. No content that makes you look like every other clinic on Instagram. Just professional content that reflects the quality of care you deliver and converts GP referrals into booked patients.',
      image: 'https://primary.jwwb.nl/pexels/69/6913295.jpeg?enable-io=true&enable=upscale&crop=0.8333%3A1&width=800'
    },
    {
      id: 2,
      title: 'AI-Powered Content Creation',
      description: 'Save hours each week while maintaining consistent, high-quality content.',
      fullDescription: 'Using AI tools combined with 11 years of social media experience, I create content that saves you hours each week while staying 100% AHPRA compliant. This isn\'t about replacing the human touch—it\'s about working smarter. I use AI to streamline content creation, ensuring you show up consistently online without it eating into the time you need for patients, theatre, and actually having a life. The result? Content that converts GP referrals and Google searches into booked patients while you focus on your craft.',
      image: 'https://primary.jwwb.nl/pexels/43/4348404.jpeg?enable-io=true&enable=upscale&crop=0.8333%3A1&width=800'
    },
    {
      id: 3,
      title: 'Online Presence Audit',
      description: 'Get clarity on what\'s working and what\'s losing you referred patients.',
      fullDescription: 'In just 20 minutes, I\'ll review your current online presence and tell you exactly what\'s working and what\'s losing you referred patients. You\'ll walk away with one actionable change you could make today to start converting more referrals. If we\'re a good fit to work together, I\'ll tell you. If we\'re not, I\'ll tell you that too. No pressure, no sales pitch—just honest feedback from someone who understands both the clinical and digital side of private obstetrics.',
      image: 'https://primary.jwwb.nl/pexels/53/533446.jpeg?enable-io=true&enable=upscale&crop=0.8333%3A1&width=800',
      ctaText: 'Book Free Audit',
      ctaLink: 'https://calendly.com/ainsleygreenslade/onlinepresenceaudit',
      external: true
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Header */}
      <section className="bg-white py-16 md:py-20">
        <div className="container mx-auto px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{ color: '#D4AF37' }}>
            Services
          </h1>
          <p className="text-center text-gray-600 max-w-3xl mx-auto">
            Specialized online presence management for private obstetricians who want to convert referrals without the overwhelm.
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="bg-gray-50 py-16 md:py-20">
        <div className="container mx-auto px-6 max-w-6xl">
          <div className="space-y-16">
            {services.map((service, index) => (
              <div 
                key={service.id} 
                className={`flex flex-col ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                } gap-8 items-center bg-white rounded-lg overflow-hidden shadow-sm p-8`}
              >
                <div className="w-full md:w-1/2">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-80 object-cover rounded-lg"
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4">
                    {service.title}
                  </h2>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {service.fullDescription}
                  </p>
                  {service.external ? (
                    <a href={service.ctaLink} target="_blank" rel="noopener noreferrer">
                      <Button 
                        className="bg-[#F0C419] hover:bg-[#D4AF37] text-black font-medium px-8 py-3 rounded transition-colors duration-200"
                      >
                        {service.ctaText}
                      </Button>
                    </a>
                  ) : (
                    <Button 
                      className="bg-[#F0C419] hover:bg-[#D4AF37] text-black font-medium px-8 py-3 rounded transition-colors duration-200"
                      onClick={() => window.location.href = '/contact'}
                    >
                      Get Started
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-[#F0C419] py-16 md:py-20">
        <div className="container mx-auto px-6 max-w-3xl text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-black mb-6">
            Ready to make your online presence work as hard as you do?
          </h2>
          <p className="text-black mb-8 text-lg">
            Book a free 20-minute audit and find out exactly what's holding you back from converting more referrals.
          </p>
          <a href="https://calendly.com/ainsleygreenslade/onlinepresenceaudit" target="_blank" rel="noopener noreferrer">
            <Button className="bg-white hover:bg-gray-100 text-black font-medium px-8 py-3 rounded transition-colors duration-200 text-lg">
              Book Your Free Audit Now
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;